import React, { Component } from "react";
import "./stockWarrantPage.css";
import BreadcrumbBar from "../breadcrumbBar";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SwiperPagination from "../swiperpagination";
import MQSGUtil from "../mqsgUtil";
import { Link } from "react-router-dom";
import ReactGA from 'react-ga4';
import IndexModal from "./IndexModal";
import DataModal from "./DataModal";
import Select from "react-select";
ReactGA.initialize('G-6VGY7GKL9V');
export default class stockWarrantPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: null,
      show: false,
      keyValue: null,
      sliderShow: false,
      highlightdata: null,
      startDate: null,
      name:'todayhighlight',
    };
  }
  componentDidMount() {
    document.title = "Stock Warrants | Singapore Warrants | Macquarie"
    this.onFetchMmbData()
  }

  onChangeSelect(value){
    if(value && value!=='hkstocks' && value!=='sgstocks'){
      this.setState({name:value})
    }
  }

  onFetchMmbData(startDateString = null, underlying = null) {
    let highlightdata = null;
    let startdate = "";
    if (startDateString !== null) {
      startdate = "&startdate=" + startDateString;
    }
    let url =
      MQSGUtil.getAPIBasePath() +
      "/NewsTableServlet?sp=todayhighlight&start=0" +
      startdate;

      // 如果有指定的underlying，添加到URL中
      if (underlying) {
        url += "&underlying=" + underlying;
      } else {
        url += ""; // 默认值
      }
      
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          highlightdata = result;
          this.setState({ highlightdata });
        },
        (error) => {
          this.setState({ highlightdata });
        }
      );
  }
  onStartDateChange(startDate) {
    this.setState({ startDate });
    const startDateString = MQSGUtil.getDateString(startDate);
    this.onFetchMmbData(startDateString);
  }
  setShow(b,i) {
    this.setState({
      show: b,
      key: i
    })
  }
  setValue(b, v,d) {
    this.setState({
      sliderShow: b,
      keyValue: v,
      name:d || this.state.name
    },()=>{
    })
  }
  render() {
    return (
      <div className="whyBox pageobj stockWarrantPage" id="indexdw">
        <BreadcrumbBar
          link="/home/edu"
          group="Warrant education"
          title="Stock Warrants"
        />
        <div className="stripe-bg"></div>
        <div className="container-fluid">
          <div className="section">
            <div className="page-header">
              <h1 >What is a stock warrant?</h1>
            </div>
            <p style={{marginBottom: '20px'}}>
              A stock warrant is a structured warrant that is issued over an underlying share. The stock call warrant tracks the performance of the underlying share i.e. it will tend to increase in value when the underlying share price increases, while stock put warrants move in an opposite direction to the underlying share price, meaning it tends to increase in value when the underlying share decreases.
            </p>
            <div>
                <div
                  className="imggrip-col col-sm-6" style={{padding: '0 10px'}} onClick={() => {
                    this.setShow(true, 5);
                }}
                >
                  <img src="/img/education/Call_warrant.jpg" alt="" />
                </div>
                <div
                  className="imggrip-col col-sm-6" style={{padding: '0 10px'}}onClick={() => {
                    this.setShow(true, 6);
                  }}
                >
                  <img src="/img/education/Put_warrant.jpg" alt="" />
                </div>
            </div>
         
            <p>Click on a tile below to learn more about Hong Kong and Singapore stock warrants.</p>
            <h1>How to trade stock warrants?</h1>
            <div className="row">
                <div id="wtkm" style={{marginTop: '10px'}}>
                    <div
                    className="imggrip-col col-sm-6"
                    onClick={() => {
                      this.setValue(true, 1,'hkstocks')
                    }}
                    >
                    <img
                        className="ppbtn"
                        src="/img/education/Hong_Kong.jpg"
                    />
                    </div>
                    <div
                    className="imggrip-col col-sm-6"
                    onClick={() => {
                      this.setValue(true, 2,'sgstocks')
                    }}
                    >
                    <img
                        className="ppbtn"
                        src="/img/education/Singapore.jpg"
                    />
                    </div>
                </div>
            </div>
            <NewsSection
              highlightdata={this.state.highlightdata}
              startDate={this.state.startDate}
              onStartDateChange={(startDate) =>
                this.onStartDateChange(startDate)
              }
              onFetchMmbData={this.onFetchMmbData.bind(this)}
              onChangeSelect={this.onChangeSelect.bind(this)}
              name={this.state.name}
            />
            <div className="page-header">
              <h1>Want to learn more?</h1>
            </div>
            <p>Click on a section below to get more in depth information on warrants.</p>
            <div id="wtkm">
              <div className="row">
                <div
                  className="imggrip-col col-sm-6"
                  onClick={() => {
                    this.setShow(true, 1);
                  }}
                >
                  <img
                    className="ppbtn"
                    src="/img/education/Want_to_learn_more_.jpg"
                  />
                </div>
                <div
                  className="imggrip-col col-sm-6"
                  onClick={() => {
                    this.setShow(true, 2);
                  }}
                >
                  <img
                    className="ppbtn"
                    src="/img/education/Want_to_learn_more_2.jpg"
                  />
                </div>
              </div>

              <div className="row">
                <div
                  className="imggrip-col col-sm-6"
                  onClick={() => {
                    this.setShow(true, 3);
                  }}
                >
                  <img
                    className="ppbtn"
                    src="/img/education/Want_to_learn_more_3.jpg"
                  />
                </div>
                <div
                  className="imggrip-col col-sm-6"
                  onClick={() => {
                    this.setShow(true, 4);
                  }}
                >
                  <img
                    className="ppbtn"
                    src="/img/education/Want_to_learn_more_4.jpg"
                  />
                </div>
              </div>
            </div>
            <hr className="hr-hmgbm" />
            
          </div>
         
        </div>
        <IndexModal keyValue={this.state.key} show={this.state.show} setShow={this.setShow.bind(this)} />
        {this.state.sliderShow && <DataModal show={this.state.sliderShow} keyValue={this.state.keyValue} setValue={this.setValue.bind(this)} />}
      </div>
    );
  }
}

class NewsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      gtag: [
        {
          category: 'ButtonClick',
          label: 'Subscribe',
          action: 'Rated an App',
          Event_category: 'ButtonClick',
          event_label: 'Subscribe',
        },
      ],
      show: false,
      warningShow: false,
      email: '',
      httpEmailText: false,
      underlyingList:[],
      selectedUnderlying:{value: '', label: 'All underlying'}
    };
    this.rows = [];
    this.pageSize = 5;
    
  }

  componentDidMount() {
    this.getUnderlyingList()
  }

  // 监听 props.name 变化
  componentDidUpdate(prevProps) {
    // 当 name 发生变化时
    if (prevProps.name !== this.props.name) {
      this.handleNameChange(this.props.name);
    }
  }

  // 处理 name 变化的逻辑
  handleNameChange(name) {
    let selectedValue = {value: '', label: 'All underlying'};
    
    // 根据 name 映射到对应的 underlying 值
    switch(name) {
      case 'hkstocks':
        selectedValue = {value: 'hkstocks', label: 'All HK stocks'};
        break;
      case 'sgstocks':
        selectedValue = {value: 'sgstocks', label: 'All SG Stocks'};
        break;
    }
    if(selectedValue.value){
      this.setState({ selectedUnderlying: selectedValue });
      // 同时触发数据获取
      if (this.props.onFetchMmbData) {
        this.props.onFetchMmbData(null, selectedValue.value);
      }
    }
  }

  // 获取下拉框参数
  getUnderlyingList() {
    let url =
      MQSGUtil.getAPIBasePath() +
      "/NewsTableServlet?sp=underlying"
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          const Result = result.map((item, i) => {
            item.label = MQSGUtil.getUnderlyingTickerDisplayName(item.underlying_ric, item.label);
          })
          result.unshift(
            { value: "", label: "All underlying" },
            // { value: "index", label: "ALL INDICES" },
            { value: "hkstocks", label: "All HK stocks" },
            { value: "sgstocks", label: "All SG Stocks" },
          )
          const filterValue=["HSTECH","HSI","N225","NDX","S&P500","SiMSCI"]
          const filteredData = result.filter(item => !filterValue.includes(item.value));
          this.setState({ underlyingList: filteredData });
        },
        (error) => {
          this.setState({ underlyingList: result });
        }
      );

    
  }

  onDotClicked(pageIndex) {
    this.setState({ current: pageIndex });
  }

  onDateChange(date) {
    this.props.onStartDateChange(date);
  }

  setupRows(highlightdata) {
    const rows = [];
    const newslist = MQSGUtil.getData(highlightdata, "newsList");
    if (newslist !== null && Array.isArray(newslist)) {
      newslist.forEach((news, index) => {
        const date = MQSGUtil.getData(news, "date");
        const title = { __html: MQSGUtil.getData(news, "en_title") };
        const short = { __html: MQSGUtil.getData(news, "en_short") };
        const id = MQSGUtil.getData(news, "id");
        const column1 = (
          <Link
              to={"/marketnews/highlight/todayhighlight/" + id}
            >
            <div className="newstbl-col-left" style={{ margin: '0px 0px 0px 10px', padding: '10px 50px 10px 10px', background: index % 2 === 0 ? '#F5F6F7' : '#fff' }}>
              <span className="newstbl-col-date">{date}</span>
              <div dangerouslySetInnerHTML={title} style={{ color: '#000', fontWeight: 'bolder' }}>
              </div>
            </div>
          </Link>
        );
        const column2 = (
          <div className="newstbl-col-right" style={{
            position: 'absolute',
            right: '5px',
            top: '18px'
          }}>
            <Link
              to={"/marketnews/highlight/todayhighlight/" + id}
            >
              <img src="/img/bullet/qlink-achor.png" alt="" />
            </Link>
          </div>
        );
        const row = (
          <div className="newstbl-row rowtmpl" key={"daily_" + id} style={{ background: '#DFDBCF', position: 'relative' }}>
            {column1}
            {column2}
          </div>
        );
        rows.push(row);
      });
    }
    this.rows = rows;
    return rows;
  }

  getRows() {
    const pageIndex = this.state.current;
    const startRowIndex = this.pageSize * pageIndex;
    const endRowIndex = this.pageSize * (pageIndex + 1);
    if (this.rows.length > endRowIndex) {
      return this.rows.slice(startRowIndex, endRowIndex);
    }
    return this.rows.slice(startRowIndex);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.highlightdata !== this.props.highlightdata) {
      this.setupRows(nextProps.highlightdata);
    }
    return true;
  }
  getbgDate(date) {
    const m = new Date().getMonth() + 1;
    const M = new Date(date).getMonth() + 1;
    const cls = m !== M ? "random" : undefined;
    return cls
  }
  setEmail(e) {
    this.setState({
      email: e.target.value,
    })
  }
  gtag_report_conversion() {
    const { email } = this.state
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!reg.test(email)) {
      this.setState({
        warningShow: true,
      });
    } else {
      const url = MQSGUtil.getAPIBasePath() + "/registration?p=register";
      fetch(
        url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: 'email=' + email
        }
      ).then((res) => res.json()).then(
        (result) => {
          this.setState({
            httpEmailText: true,
            show: false
          }, () => {
            window.setTimeout(() => {
              this.setState({
                httpEmailText: false,
                show: false
              })
            }, 3000)

          })
        },
        (error) => {
        }
      );
    }
  }
  popUp(e, val) {
    e.stopPropagation()
    ReactGA.event('Index', this.state.gtag[0])
    this.setState({
      show: val,
      email: '',
      warningShow: false,
    })
  }

  onChange(selected) {
    const selectedValue = selected ? selected.value : "";
    this.setState({ selectedUnderlying: selected });
    // 调用 onFetchMmbData，传递选中的 underlying 参数
    if (this.props.onFetchMmbData) {
      this.props.onFetchMmbData(null, selectedValue);
      this.props.onChangeSelect(selectedValue)
    }
  }

  render() {
    const rows = this.getRows();
    return (
      <div
        id="newssection"
        style={{ position: "relative", padding: '0px' }}
        className="section"
      >
        <div className="page-header" style={{ minHeight: '40px', borderBottom: '1px solid #FECC0A',display: "block" }}>
          <h3 className="section-p" style={{minHeight: 0}}>
            Newsletter articles on stock warrants
          </h3>
          {/* 下拉框 */}
          <div className="searchbox searchbox-toppage input-group" style={{ width: '35%',marginBottom: '10px' }}>
            <div id="powersearch">
              <Select
                className="center"
                placeholder="Select underlying"
                options={this.state.underlyingList}
                onChange={this.onChange.bind(this)}
                value={this.state.selectedUnderlying}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "center",
                    ':hover': {
                      backgroundColor: '#1A73E8',
                    }
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    justifyContent: 'center'
                  })
                }}
              />
            </div>
          </div>
        </div>
        <div id="commentarytbl" className="newstbl">
          <div className="newstbl-content" style={{ color: '#0675C2', overflow: 'hidden', marginBottom: '15px' }}>{rows}</div>
          <div className="newstbl-bttm">
            <SwiperPagination
              current={this.state.current}
              rows={this.rows}
              pageSize={this.pageSize}
              onDotClicked={(pageIndex) => this.onDotClicked(pageIndex)}
            />
            <div className="newstbl-col-rm">
              <div style={{ color: '#3F312D', fontSize: '22px' }}>
                Sign up for our daily newsletter for the latest updates on the market
              </div>
              <button
                className="btn btn-primary btn-default"
                target="_blank"
                style={{
                  padding: '10px 30px 10px 30px',
                  height: '55px', fontSize: '22px', marginTop: '10px'
                }}
                onClick={(e) => { this.popUp(e, true) }}
              >
                Subscribe
              </button>
            </div>
          </div>
          <hr className="hr-hmgbm" />
        </div>
        {/* pop-up */}
        <div
          id="disclaimer-ppboxHTML"
          className="disclaimer-overlay"
          style={{ display: this.state.show ? 'block' : 'none' }}
        >
          <div className="overlay-inner">
            <div className="popupbox-content">
              <div className="signup-layer">
                <p style={{ float: 'right', fontSize: '20px', cursor: 'pointer' }} onClick={(e) => this.popUp(e, false)}>X</p>
                <div className="page-header">
                  <h3>Sign up now</h3>
                </div>
                <input type="text" id="email" placeholder="Email" value={this.state.email} onChange={(e) => { this.setEmail(e) }} />
                <div className="warning" style={{ visibility: this.state.warningShow ? 'visible' : 'hidden' }}>invalid email</div>
                <p className="small">
                  By clicking "Submit", you confirm that you would like to subscribe to Macquarie’s daily warrant newsletter. By subscribing, you will also automatically receive invitations or marketing material from Macquarie for warrant seminars and other warrant related initiatives. Macquarie website administrators may have access to your personal data for the processing of such data on behalf of Macquarie Capital Securities (Singapore) Pte Ltd and other companies of Macquarie Group (“Macquarie”).
                  <br /><br />
                  Please read the <a target="_blank" href="/about/privacypolicy">privacy policy</a> and <a target="_blank" href="/about/importantinformation">important information</a> via the links at the bottom of this page to understand how your personal information will be treated by Macquarie.
                </p>
                <input type="button" id="submitBtn" value="Submit" onClick={() => this.gtag_report_conversion()} />
              </div>
            </div>
          </div>
        </div>
        {/* pop-up */}
        <div id="popup-customized" style={{ display: this.state.httpEmailText ? 'table' : 'none' }}>
          <div>
            <h5>You have successfully registered for our daily newsletter!</h5>
          </div>
        </div>
      </div>
    );
  }
}